import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { publicApi } from "../lib/api";
import AskCassieAnswer from "./AskCassieAnswer";
import AskCassieCategory from "./AskCassieCategory";
import NotFound from "./NotFound";

/**
 * Categories and answers share one level of the URL on purpose — an answer never
 * sits inside a category, so recategorising can't break a link. The server says
 * which of the two a slug is, so the browser never has to guess.
 */
export default function AskCassieSlug() {
  const { slug } = useParams();
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    setState({ loading: true });
    publicApi
      .askCassieResolve(slug)
      .then((d) => setState({ ...d }))
      .catch(() => setState({ missing: true }));
  }, [slug]);

  if (state.missing) return <NotFound />;
  if (state.loading) return <div className="py-32 text-center text-sm text-slate-400">Loading…</div>;
  // A quick answer has no page of its own; it lives on its category page.
  if (state.kind === "redirect") return <Navigate to={state.to} replace />;
  if (state.kind === "category") return <AskCassieCategory category={state.category} />;
  return <AskCassieAnswer answer={state.answer} />;
}
